module.exports = __webpack_public_path__ + "static/img/6292_phase_function_Paper_Points.5542c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6292_phase_function_Paper_Points.png
// module id = Vymp
// module chunks = 0